import {
  Table,
  Tbody,
  Tr,
  Td,
  TableContainer,
  Image,
  Flex,
  Text,
} from '@chakra-ui/react'
import { ContentPublish } from '@/types/content';

type Props = {
  pubContent: ContentPublish;
}
const PubContent = (props: Props) => {
  
  return (
    <TableContainer >
      <Table >
        <Tbody>
          <Tr fontSize="12px" >
            <Td border={"none"} verticalAlign={"top"} color={"#6C7596"}>创意描述</Td>
            <Td border={"none"}>
              <Flex>
                <Text color={"#FFFFFF"} whiteSpace="normal">
                  {props.pubContent.prompt}
                </Text>
              </Flex>
              
              </Td>
          </Tr>
          <Tr fontSize="12px">
            <Td border={"none"} verticalAlign={"top"} color={"#6C7596"}>模型版本</Td>
            <Td border={"none"} color={"#FFFFFF"}>{props.pubContent.style}</Td>
          </Tr>
          
          {
            props.pubContent.ref_style &&
            <Tr fontSize="12px">
              <Td border={"none"} verticalAlign={"top"} color={"#6C7596"}>风格参考图</Td>
              <Td border={"none"}><Image src={props.pubContent.ref_style} alt='参考样式图' w="70px" h="70px" /></Td>
            </Tr>
          }
          {/* <Tr fontSize="12px">
            <Td border={"none"} verticalAlign={"top"} color={"#6C7596"}>出图数量</Td>
            <Td border={"none"} color={"#FFFFFF"}>{props.pubContent.n_iter}</Td>
          </Tr> */}
        </Tbody>
      </Table>
    </TableContainer>

  )
}

export default PubContent